import { Component, OnInit, Input,Output ,EventEmitter} from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { TermsComponent } from '../terms/terms.component';
import { MatDialog, MatDialogConfig  } from '@angular/material';

@Component({
  selector: 'app-security-code',
  templateUrl: './security-code.component.html',
  styleUrls: ['./security-code.component.sass']
})
export class SecurityCodeComponent implements OnInit {

  @Input() viewSession;
  @Input() account;
  @Input() txtType;
  @Input() accountType;
  @Input() accountSubType;
  
  public acceptedTerms;
  public securityCode;
  public email;
  public ssn;
  public subscriber;

  @Output() updateView = new EventEmitter<number>();
  @Output() updateEmail = new EventEmitter<number>();
  @Output() updateSsn = new EventEmitter<number>();
  @Output() updateSubscriber = new EventEmitter<string>();
  @Output() updateSecurityCode = new EventEmitter<number>();
  
  constructor(private global:GlobalService,  private loadingScreenService :LoadingScreenService ,private services: Service, public dialog:MatDialog) { }

  ngOnInit() {
      this.securityCode='';
      this.ssn='';
  } 
  resendCode() {
    this.loadingScreenService.startLoading();
    this.services.validateAccount(this.account).subscribe(data =>{
      this.loadingScreenService.stopLoading();
      if(data.hasError==false){
        this.global.notif('Código de seguridad enviado.');
      }
      else{
        this.global.notif(data.errorDisplay);
      }
    });
  }
  terms(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true
    const dialogRef =this.dialog.open(TermsComponent, dialogConfig);
  }
  submitForm() {
      if (this.acceptedTerms) {
        this.loadingScreenService.startLoading();
        if (this.global.validarEmail(this.email)) {
              this.services.getVerifyEmail(this.email).subscribe(data =>{
                  if (data.hasErrorField===true) {
                    this.loadingScreenService.stopLoading();
                    this.global.notif(data.errorDescField);    
                  } 
                  else {
                      this.services.validateSSNAndEmail(this.account, this.ssn, this.email,this.securityCode).subscribe(data =>{
                        this.loadingScreenService.stopLoading();
                        if (data.hasError==false) {
                            this.viewSession = 3;
                            this.updateSubscriber.emit(data.message);
                            this.updateView.emit(this.viewSession);
                            this.updateEmail.emit(this.email);
                            this.updateSsn.emit(this.ssn);
                            this.updateSecurityCode.emit(this.securityCode);
                        } 
                        else {
                          this.global.notif(data.errorDisplay);                     
                        }
                    });
                  }
              });
          } 
          else {
            this.loadingScreenService.stopLoading();
            this.global.notif('Debe colocar un correo electrónico válido.');
          }
      } 
      else {
        this.global.notif('Debe aceptar los términos.');
      }
  }
  validateInputs() {
    var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if ( (this.accountType === 'I' && this.accountSubType === 'P') || (this.accountType === 'I3' && this.accountSubType === 'P') ) {
        return emailRegex.test(this.email) && this.acceptedTerms && this.securityCode.length > 0;
    } 
    else {
        return (
            this.ssn.length > 0 &&
            this.ssn.length === 4 &&
            emailRegex.test(this.email) &&
            this.acceptedTerms &&
            this.securityCode.length > 0
        );
    }
  }
}